<template>
  <div class="container-box"  
       @mouseenter="mouseEnter"
       @mouseleave="mouseLeave">
    <div class="content-box">
        <img :src="item.icon"/>
        <span :class="isEn && !item.details ? 'en-title' : 'title'">{{$t(item.title)}}</span>
        <div>
          <p v-for="(des, index) in item.descriptions" 
                :key="index"
                :class="isEn && !item.details ? 'en-desText' : 'desText'"
                >{{$t(des)}}</p>
        </div>
    </div>
    <transition>
      <div class="description-box" 
           v-show="detailVisible && item.details" 
          >
          <div class="flex-box">
            <p v-for="(detail, index) in item.details" 
              :key="index"
              :class="isEn ? 'en-desText' : 'desText'"
              v-html="$t(detail)"
              >
            </p>
          </div>
      </div>
    </transition>

  </div>
</template>

<script>
export default {
  
  props: ['item'],
  data(){
    return {
      isEn: false,
      detailVisible: false,
    }
  },

  created(){
    const locale = localStorage.getItem('locale');
    if(locale === 'zh'){
      this.isEn = false;
    }else{
      this.isEn = true;
    }
  },

  watch: {
    '$i18n.locale'(){
      const locale = localStorage.getItem('locale');
      if(locale === 'zh'){
        this.isEn = false;
      }else{
        this.isEn = true;
      }
    }
  },

  methods:{
    mouseEnter(){
      this.detailVisible = true;
    },
    mouseLeave(){
      this.detailVisible = false;
    }
  }

}
</script>

<style lang="less" scoped>

.container-box{
  width: 220px; /*no*/
  height: 264px; /*no*/
  background-color: #fff;
  box-shadow:0px 2px 8px 0px rgba(0,0,0,0.04);
  border-radius:15px;
  position: relative;
  margin-bottom: 30px;/*no*/
}

.content-box{
  height: 100%;
  display: flex;
  flex-direction:column;
  justify-content: space-around;
  align-items: center;

  img{
    object-fit: contain;
    margin-top: 30px;/*no*/
    width: 60px;/*no*/
    height: 60px;/*no*/
  }
  .title{
    font-size:20px; /*no*/
    font-family:PingFangSC-Medium,PingFang SC;
    font-weight:500;
    line-height: 1.2;
    margin: 0 10px;
  }
  .en-title{
    font-size: 18px;/*no*/
    font-weight:500;
    line-height: 1.2;
  }

  .desText{
    font-size: 15px; /*no*/
    color: #666;
    font-weight: 600;
    line-height: 1.2;
  }
  .en-desText{
    font-size: 13px; /*no*/
  }
}

.description-box{
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: #000;
  opacity: 0.72;
  top: 0;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  
  .flex-box{
    margin: 10px auto 0;/*no*/
  }
  p{
    color: #fff;
    font-size: 15px; /*no*/
    line-height: 1.1;
    // line-height: 30px;/*no*/
    // margin: 0;
    margin-top: 30px;/*no*/
    // font-weight:400;
  }
  .en-desText{
    font-size: 14px; /*no*/
    line-height: 1.2;
  }

}

.v-enter-active{ 
  transition: all 0.35S ease-in
}
.v-leave-active{
  transition: 0.1s ease-out;
}

@media only screen and (max-width: 992px) {
  .container-box{
    width: 180px; /*no*/
    height: 220px; /*no*/

    img{
      width: 60px;/*no*/
      height: 60px;/*no*/
    }
    .title{
      font-size: 20px;/*no*/
    }

    .desText{
      font-size: 15px; /*no*/
    }
    .description-box{
      height: 220px; /*no*/
      p{
        font-size: 14px; /*no*/
        margin-top: 22px; /*no*/
      }
    }
  }
}

</style>


// WEBPACK FOOTER //
// src/components/HomeItem.vue